import ResourceModel from "models/convention-api/ResourceModel"

export default class SessionAttachment extends ResourceModel {
  protected static basePath = "/v1/convention_providers/:provider_id/session_attachments"

  caption!: string
  convention_session_id!: string
  url!: string
}
